export const resourceAssigned =
  (steps) =>
  ({ name }) =>
    !!(steps.length && name && name.length)

export const stepInProgress = (step) => step.status === 'DOING'
export const stepFinished = (step) => step.status === 'DONE'
export const stepPending = (step) => step.status === 'PENDING'
export const firstUnfinishedStepIndex = (steps) => steps.findIndex((step) => !stepFinished(step))
export const allPending = (steps) => steps.every((step) => stepPending(step))
export const getCurrent = (steps) => {
  const stepIndex = firstUnfinishedStepIndex(steps)
  if (stepIndex === -1) {
    return steps.length
  }

  if (allPending(steps)) {
    return -1
  }
  const prevStepIndex = stepIndex - 1 < 0 ? stepIndex : stepIndex - 1
  return stepFinished(steps[prevStepIndex]) || stepInProgress(steps[stepIndex]) ? stepIndex : prevStepIndex
}
